module.exports = __webpack_public_path__ + "media/marketing_area/Dynamic-Paint-Brush-Header-89bef0c7.jpg";